<template>
	<div class="big about_us" style="padding-top: 0 !important;background: #fcfcfc;">
		<navigation></navigation>
			<div class="logo_wrap_jd" style="margin-top: 0.38rem;">
			</div>
			<p class="text-center mt16 font34 color6 mb32">交道</p>
			<div class="content1 font34">
				<div class="qq">
					<div>QQ客服群</div>
					<div class="color9 font30 mt16 mb16">
						<span class="span1">客服</span>
						<span id="span2">658730778</span>
						<span id="span3">长按号码复制</span>
					</div>
				</div>
				<div class="wechat">
					<div>微信客服群</div>
					<div class="color9 font30 mt16 mb16">打开微信扫描下方二维码，或搜索“ZPKJ55”,添加好友后发送“省市+教育类型”即可拉您入群</div>

					<div id="savePic">
						<img id='saveImg' src="../../../assets/img/aboutUs/jxm.jpg" style="width: 1.32rem;height: 1.32rem;"/>
						<div class="color9 font28 dj" style="vertical-align: bottom;">长按图片保存到相册</div>
					</div>
				</div>
				<div class="wechat">
					<div>微信公众号</div>
					<div class="color9 font30 mt16 mb16">打开微信扫描下方二维码，或搜索并关注公众号“交道APP”</div>
				
					<div id="savePic">
						<img id='saveImg' src="../../../assets/img/aboutUs/pubilc_code.png" style="width: 1.32rem;height: 1.32rem;"/>
						<div class="color9 font28 dj" style="vertical-align: bottom;">长按图片保存到相册</div>
					</div>
				</div>
				
				<div class="sina">
					<div>官方微博</div>
					<div class="color9 font30 mt16 mb16">打开微博搜索“交道APP”</div>
				</div>
			</div>
			<div class="content2">
				<img src="../../../assets/img/aboutUs/class_logo.png"/>
				<p class="p2">交道教育</p>
				<!-- <p class="p2">交通第二课堂</p> -->
				<p class="p3">全行业课程定制服务、大平台技术支持服务、私有化内部培训服务，更多优秀案例及信息化解决方案，期待与您合作！</p>
			</div>
			<div class="div1">
				<div>微信搜索“交道课堂”公众号或“交道教育”小程序</div>
			</div>
			<div class="div2 font30">
				商务合作：132 &nbsp;6026 &nbsp;1131（周先生）
			</div>
			<div class="div3 font30">
				136 &nbsp;6106 &nbsp;5623（陈先生）
			</div>
		</div>
</template>
<script>
	// import {
	// 	Loading,
	// 	Tab,
	// 	Tabs,
	// 	Card
	// } from 'vant'
	import navigation from "../../components/nav";
	import request from '@/utils/request'
	export default {
		components: {
			navigation,
		},
		data() {
			return {
				
			}
		},
		created() {
		
		},
		methods: {
			 copymsg() {
        var Url2 = document.getElementById("span2");//要复制文字的节点
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {//区分iPhone设备
            window.getSelection().removeAllRanges();//这段代码必须放在前面否则无效
            var range = document.createRange();
            // 选中需要复制的节点
            range.selectNode(Url2);
            // 执行选中元素
            window.getSelection().addRange(range);
            // 执行 copy 操作
            var successful = document.execCommand('copy');

            // 移除选中的元素
            window.getSelection().removeAllRanges();
						alert(1111)
        } else {
            Url2.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
						alert(222)
        }
    },
		btn(){
			this.copymsg();
		},
		}
	}
</script>

<style scoped>
.big{
	width: 100%;
	text-align: justify;
}
.font36{
	font-size: 0.36rem;
}
.font34{
	font-size: 0.34rem;
}
.font32{
	font-size: 0.32rem;
}
.font30{
	font-size: 0.30rem;
}
.font28{
	font-size: 0.28rem;
}
.font26{
	font-size: 0.26rem;
}
.padH30{
	padding: 0 0.3rem;
}
.mb16{
	margin-bottom: 0.16rem;
}
.mb32{
	margin-bottom: 0.32rem;
}
.mb40{
	margin-bottom: 0.4rem;
}
.mb50{
	margin-bottom: 0.5rem;
}
.mb60{
	margin-bottom: 0.6rem;
}
.mt16{
	margin-top: 0.16rem;	
}

.color3{
	color: #333;
}
.color6{
	color: #666;
}
.color9{
	color: #999;
}
.pl6{
	padding-left: 6px;
}
.exchange_wrap{
	padding: 0.4rem 0.3rem;
	line-height: 0.55rem;
}
.fw500{
	font-weight: 700;
}
.exchange_wrap .boL{
	border-left: 2px solid #12DEC3;
	padding-left: 6px;
	height: 0.28rem;
	line-height: 1;
	margin-bottom: 0.2rem;
	margin-top: 0.22rem;
}
/* .logo_wrap{
	width: 2.04rem;
	height: 2.04rem;
	margin: 0 auto;
	background: url(../img/logo.png) no-repeat;
	background-size: cover;
} */
.dj{
	display: inline-block;
	margin-bottom: 0.16rem;
}
.logo_wrap_jd{
	width: 2.04rem;
	height: 2.04rem;
	margin: 0 auto;
	background: url(../../../assets/img/aboutUs/logo_jd.png) no-repeat;
	background-size: cover;
}
.text-center{
	text-align: center;
}
.text-indent{
	text-indent: 2em;
}
.lineH60{
	line-height: 0.6rem;
}
.about_us{
	background: #F9F9F9;
	padding-top: 0.35rem;
	padding-bottom: 0.35rem;
}
.about_us .content1{
	width: 82%;
	margin: 0 auto;
	background: #fff;
	padding-bottom: 0.35rem;
	border-radius: 0.32rem;
}
.about_us .wechat{
	background: url(../../../assets/img/aboutUs/wechat_logo.png) no-repeat 0.2rem 0.4rem;
	background-size: 0.6rem 0.5rem;
	padding: 0.4rem 0.6rem 0 1rem;
	
}
.about_us .pubilc_code{
	background: url(../../../assets/img/aboutUs/pubilc_code.png) no-repeat -0.1rem ;
	background-size: 1.32rem 1.32rem;
	padding: 0.8rem 0.6rem 0 1.34rem;
}
.about_us .sina{
	background: url(../../../assets/img/aboutUs/sina_logo.png) no-repeat 0.2rem 0.4rem;
	background-size: 0.6rem 0.5rem;
	padding: 0.4rem 0.6rem 0 1rem;
}
.about_us .qq{
	background: url(../../../assets/img/aboutUs/qq_logo.png) no-repeat 0.2rem 0.4rem;
	background-size: 0.46rem 0.5rem;
	padding: 0.4rem 0.6rem 0 1rem;
}
.about_us .qq .span1{
	color: #999999;
	font-size: 0.3rem;
	margin-right: 0.38rem;
}
.about_us .qq #span2{
	color: #999999;
	font-size: 0.3rem;
	margin: 0 ;
}
.about_us .qq #span3{
	color: #F63C45;
	/* border: 0.02rem solid #F63C45 ; */
	font-size: 0.24rem;
	margin-left: 0.38rem;
	padding: 0.08rem 0.14rem;
	border-radius: 0.04rem;
}

.about_us .content2{
	padding-top: 0.36rem;
}
.about_us .content2 img{
	display: block;
	width: 2.04rem;
	height: 2.04rem;
	margin: 0 auto;
}
.about_us .content2 .p2{
	width:82%;
	margin: 0.18rem auto 0.18rem;
	color: #666666;
	font-size: 0.34rem;
	text-align: center;
}
.about_us .content2 .p3{
	width:82%;
	margin: 0.3rem auto 0.4rem;
	color: #333;
	font-size: 0.32rem;
	line-height: 0.6rem;
}
.about_us .div1{
	width:82%;
	overflow: hidden;
	margin: 0 auto;
	/* margin: 0 auto 0.3rem; */
	/* color: #999; */
	background: url(../../../assets/img/aboutUs/wechat_logo.png) no-repeat 0.2rem center;
	background-size: 0.6rem 0.5rem;
	background-color: #fff;
	

}
.about_us .div1 div{
	font-size: 0.3rem;
	margin: 0.2rem 0.8rem 0.2rem 1rem;
}
.about_us .div2{
	width:82%;
	margin: 0 auto;
	background: url(../../../assets/img/aboutUs/business.png) no-repeat left center ;
	background-size: 0.36rem 0.3rem;
	/* padding-left: 0.7rem; */
	color: #F63C45;
	height: 0.9rem;
	line-height: 1rem;
	text-align: center;
}
.about_us .div3{
	margin: 0 auto;
	color: #F63C45;
	text-align: center;
	margin-left: 1.5rem;
}

	
</style>
